import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function RequireRole({ allowed, children }) {
  const { user, status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return null;
  }

  if (!user) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: location.pathname },
        }}
      />
    );
  }

  if (!allowed.includes(user.role)) {
    const fallback =
      user.role === "admin"
        ? "/admin"
        : user.role === "member"
        ? "/market-data"
        : "/";
    return <Redirect to={fallback} />;
  }

  return <>{children}</>;
}
